import React, { useEffect, useMemo, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";

const InventoryValidationTable = ({
  additionalData,
  pagination,
  showDrawer,
  totalCount,        // ← new prop
}) => {
  const data = useMemo(() => additionalData || [], [additionalData]);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  useEffect(() => {
    pagination({
      limit: paginationModel.pageSize,
      offset: paginationModel.pageSize * paginationModel.page,
    });
  }, [paginationModel]);

  const muiColumns = useMemo(
    () => [
      { field: "id", headerName: "ID", flex: 1 },
      { field: "create_date",     headerName: "Create Date", flex: 2 },
      { field: "no_of_items",     headerName: "No. of Items", flex: 1 },
    ],
    []
  );

  return (
    <Box  sx={{
                height: 600,
                width: "100%",
                "& .MuiDataGrid-root": {
                  border: "none",
                  borderRadius: "12px",
                  overflow: "hidden",
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "13px",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                  backgroundColor: "#fff",
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#EBF7FD",
                  borderBottom: "1.5px solid #78CFEC",
                  minHeight: "48px !important",
                },
                "& .MuiDataGrid-columnHeader": {
                  padding: "0 16px",
                  color: "#1A6F8A",
                  fontWeight: 600,
                  fontSize: "12.5px",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                },
                "& .MuiDataGrid-columnSeparator": {
                  display: "none",
                },
                "& .MuiDataGrid-cell": {
                  padding: "0 16px",
                  borderBottom: "1px solid #F0F4F8",
                  color: "#272728",
                  display: "flex",
                  alignItems: "center",
                },
                "& .MuiDataGrid-row": {
                  minHeight: "52px !important",
                  transition: "background 0.15s ease",
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#F0F9FD",
                  cursor: "pointer",
                },
                "& .MuiDataGrid-row.Mui-selected": {
                  backgroundColor: "#DBEEFA !important",
                },
                "& .MuiDataGrid-row.Mui-selected:hover": {
                  backgroundColor: "#CCE8F6 !important",
                },
                "& .MuiDataGrid-checkboxInput": {
                  color: "#78CFEC",
                },
                "& .MuiCheckbox-root.Mui-checked": {
                  color: "#0EA5D0",
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "1.5px solid #E2EEF4",
                  backgroundColor: "#F7FBFD",
                  minHeight: "48px",
                },

                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: "#FAFCFE",
                },
                "& .MuiDataGrid-overlayWrapper": {
                  minHeight: "120px",
                },
                "& .MuiDataGrid-columnHeaderTitleContainer": {
                  gap: "4px",
                },
                "& .MuiDataGrid-sortIcon": {
                  color: "#78CFEC",
                },
                "& .MuiDataGrid-menuIcon": {
                  color: "#78CFEC",
                },

                "& .MuiTablePagination-selectLabel": {
                  display: "none",   // hides "Rows per page"
                },
              }}>
    <DataGrid
  rows={data}
  columns={muiColumns}
  getRowId={(row) => row.id}
  onRowClick={(params) => showDrawer(params.row)}
  disableRowSelectionOnClick
  paginationMode="server"
  rowCount={totalCount ?? 0}
  paginationModel={paginationModel}
  onPaginationModelChange={setPaginationModel}
  pageSizeOptions={[10, 25, 50]}
/>
    </Box>
  );
};

export default InventoryValidationTable;